import { render, staticRenderFns } from "./UpdateData.vue?vue&type=template&id=a7128fdc"
import script from "./UpdateData.vue?vue&type=script&lang=js"
export * from "./UpdateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7128fdc')) {
      api.createRecord('a7128fdc', component.options)
    } else {
      api.reload('a7128fdc', component.options)
    }
    module.hot.accept("./UpdateData.vue?vue&type=template&id=a7128fdc", function () {
      api.rerender('a7128fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/UpdateData.vue"
export default component.exports